import { Button } from "@/components/ui/button";
import founder from "@/assets/founder-apache.jpg";
import { useLeadFunnel } from "@/contexts/LeadFunnelContext";

export const About = () => {
  const { open } = useLeadFunnel();
  return (
    <section id="about" className="section-pad bg-charcoal text-warm-white">
      <div className="container-tight grid gap-12 lg:grid-cols-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <div className="relative">
            <div className="absolute -inset-3 border border-brass/40 -z-10" aria-hidden />
            <img
              src={founder}
              alt="Jonathan Apache Pacheco — Founder of Golden State Project Works"
              loading="lazy"
              width={1024}
              height={1024}
              className="w-full aspect-[4/5] object-cover grayscale-[15%]"
            />
          </div>
        </div>
        <div className="lg:col-span-7 space-y-8">
          <div className="space-y-5">
            <span className="eyebrow">Built by Apache</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-warm-white leading-[1]">
              East LA Roots.
              <br />
              <span className="text-brass">Professional Results.</span>
            </h2>
          </div>

          <div className="space-y-4 text-warm-white/80 text-base md:text-lg leading-relaxed">
            <p>
              Golden State Project Works wasn't built in a boardroom—it was built in an East Los
              Angeles garage.
            </p>
            <p>
              Jonathan Pacheco grew up learning that precision isn't optional. As the son of a
              master mechanic, he understood early: if the work isn't right, it doesn't hold.
            </p>
            <p className="text-warm-white">That standard carried into the field.</p>
          </div>

          <div className="space-y-4 border-l-2 border-brass/60 pl-5">
            <div className="font-display text-xl md:text-2xl text-warm-white uppercase tracking-wide">
              The Apache Standard
            </div>
            <p className="text-warm-white/80 text-base md:text-lg leading-relaxed">
              "Apache" isn't just a name—it's how the work gets done.
            </p>
            <ul className="space-y-2 text-warm-white/80 text-base md:text-lg">
              <li className="flex gap-3">
                <span className="text-brass">▸</span>
                <span>The resilience to handle heavy, difficult jobs</span>
              </li>
              <li className="flex gap-3">
                <span className="text-brass">▸</span>
                <span>The discipline to finish what others leave behind</span>
              </li>
              <li className="flex gap-3">
                <span className="text-brass">▸</span>
                <span>The standard of doing it right the first time</span>
              </li>
            </ul>
          </div>

          <div className="space-y-3 text-warm-white/80 text-base md:text-lg leading-relaxed">
            <p>When you hire Golden State, you're not hiring a random crew.</p>
            <p className="text-warm-white">
              You're hiring someone who treats every job like it carries his name.
            </p>
          </div>

          <div className="flex items-center gap-4 border-t border-warm-white/10 pt-6">
            <div className="h-12 w-1 bg-gradient-brass" />
            <div>
              <div className="font-display text-lg text-warm-white tracking-wide">
                Jonathan "Apache" Pacheco
              </div>
              <div className="text-[11px] uppercase tracking-[0.25em] text-brass">Founder</div>
            </div>
            <Button variant="brass" size="sm" className="ml-auto" onClick={open}>
              Contact Jonathan Directly
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
